import React, { useState } from 'react';

import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import Snackbar from 'components/DesignSystem/Snackbar';
import useAutomaticOptions from 'utils/hooks/flux/useAutomaticOptions';
import useFluxAutomaticFilterSelector from 'utils/hooks/flux/automatic/filterSelector';
import { SpatialSubdivision as SpatialSubdivisionKey, automaticOptionMap } from 'helper/flux/automatic';

import './index.scss';

// No desktop isto é um Dropdown de 4 tipos que abre um modal com as suboções.
// No mobile o mesmo par vira dois níveis dentro da própria seção do sheet.
export default function SpatialSubdivision({ onPicked }: { onPicked: () => void }) {
  const [type, setType] = useState<SpatialSubdivisionKey | undefined>();
  const { subdivisions, isFetching } = useAutomaticOptions();
  const { currentSubOption, setFilterWithinDivision } = useFluxAutomaticFilterSelector();

  if (isFetching) {
    return <Snackbar className="mt-2">Carregando opções…</Snackbar>;
  }

  if (!type) {
    return (
      <>
        {Object.entries(automaticOptionMap).map(([key, label]) => (
          <OptionRow
            key={key}
            label={label}
            selected={currentSubOption?.spatialSubdivision === key}
            onSelect={() => setType(key as SpatialSubdivisionKey)}
          />
        ))}
      </>
    );
  }

  const suboptions = subdivisions[type] ?? [];

  return (
    <>
      <button
        type="button"
        className="flux-automatic-subdivision-back"
        onClick={() => setType(undefined)}
      >
        {`← ${automaticOptionMap[type]}`}
      </button>
      {suboptions.length === 0 && (
        <Snackbar className="mt-2">Nenhuma opção disponível.</Snackbar>
      )}
      {suboptions.map((option) => (
        <OptionRow
          key={`${option.value}-${option.label}`}
          label={option.label}
          selected={currentSubOption?.spacialSubdivisionOption.label === option.label}
          onSelect={() => {
            setFilterWithinDivision(option, type);
            setType(undefined);
            onPicked();
          }}
        />
      ))}
    </>
  );
}
